import type { SupportContext } from '@/lib/schemas/support.schema';
import { collector } from './collector';
import type { ContextSources } from './context';

// ── L'ordinateur, pour le contexte d'un probleme : navigateur, ecran, zoom, langue, fuseau, carte graphique ──

type Env = NonNullable<SupportContext['env']>;

export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION ?? 'dev';

/** La carte graphique, lue sur un canvas jetable, detruit aussitot */
function readGpu(): string | undefined {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl');
    if (!gl) return undefined;
    const info = gl.getExtension('WEBGL_debug_renderer_info');
    const gpu = info ? gl.getParameter(info.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER);
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    return typeof gpu === 'string' ? gpu.slice(0, 300) : undefined;
  } catch {
    return undefined;
  }
}

const gpuField = () => { const gpu = readGpu(); return gpu ? { gpu } : {}; };

export function readEnvironment(live?: boolean): Env {
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  return {
    userAgent: navigator.userAgent,
    ...(uaData?.platform || navigator.platform ? { platform: uaData?.platform || navigator.platform } : {}),
    screen: `${screen.width}×${screen.height}`,
    viewport: `${window.innerWidth}×${window.innerHeight}`,
    dpr: window.devicePixelRatio,
    language: navigator.language,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...gpuField(),
    version: APP_VERSION,
    ...(process.env.NEXT_PUBLIC_COMMIT_SHA ? { commit: process.env.NEXT_PUBLIC_COMMIT_SHA } : {}),
    ...(live !== undefined ? { live } : {}),
  };
}

/** Ce que le contexte d'une demande lit maintenant, hors de l'editeur */
export function readContextSources(live?: boolean): ContextSources {
  return {
    page: { path: window.location.pathname, title: document.title },
    env: readEnvironment(live),
    collected: collector.read(),
  };
}
